import HomePresenter from "./HomePresenter";
import { useState, useEffect, useContext, useRef } from 'react';
import { ScreenContext } from "../../components/ScreenProvider";
import { MainBannerList, CIList } from "../../assets/datas/ConstantLists";

const HomeContainer = () => {
  const screen = useContext(ScreenContext).style;

  const [currentSectionIndex, setCurrentSectionIndex] = useState<number>(0);
  const boxContainerRef = useRef<HTMLDivElement>(null);

  const scrollToSection = (section: any) => {
    if (!boxContainerRef.current) return;
    if (section instanceof HTMLElement) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "start" });
    }
  };

  let sY = 0;

  const handleTouchStart = (e) => {
    // e.preventDefault()
    sY = e.touches[0]?.pageY;
  };

  // const handleTouchMove = (e) => {
  //   // e.preventDefault()
  // };

  // const handleTouchEnd = (e) => {
  //   const start = sY;
  //   const end = e.changedTouches[0]?.pageY;
  //   if(start - end > 0) {
  //     // console.log("down");
  //   }
  //   else {
  //     // console.log("up");
  //   }
  // };

  useEffect(() => {
    // console.log(currentSectionIndex);
  }, [currentSectionIndex]);

  const checkWheel = (e) => {
    let delta = 0;
    if(e.deltaY) {
      delta = e.deltaY;
    }
    else if(e.changedTouches && e.changedTouches.length > 0) {
      const start = sY;
      const end = e.changedTouches[0]?.pageY;
      delta = start - end;
    }
    
    const main = document.getElementById("main");
    const sections = document.querySelectorAll('.section');
    if(delta > 0 && currentSectionIndex === sections.length - 2) {
      scrollToSection(sections[sections.length - 1]);
    }

    if(delta < 0 && (main.scrollTop > 0 || currentSectionIndex === sections.length - 2)) {
      main.scrollTo({ top: 0, behavior: "smooth" });
    }

  };

  const handleScroll = (e) => {
    // console.log(e.target.scrollTop);
    let margin = 100;
    if(screen === "tablet") {
      margin = 200;
    } else {
      margin = 100;
    }
    const targetSectionIndex = Math.floor(
      e.target.scrollTop / (window.innerHeight - margin)
    );
    setCurrentSectionIndex(targetSectionIndex);
  };

  useEffect(() => {

    const handleWheel = (e: WheelEvent) => {
      if (!boxContainerRef.current || screen !== "pc") return;

      const delta = e.deltaY;
      const currentSectionIndex = Math.round(
        boxContainerRef.current.scrollTop / (window.innerHeight - 90)
      );
      
      let targetSectionIndex = currentSectionIndex;

      const sections = document.querySelectorAll('.section');

      if (delta > 0 && currentSectionIndex < sections.length - 1) {
        e.preventDefault();
        targetSectionIndex += 1;
      } else if (delta < 0 && currentSectionIndex > 0) {
        e.preventDefault();
        const mainEl = document.getElementById("main");
        if(mainEl.scrollTop > 300) {
          targetSectionIndex = sections.length - 1;
        }
        targetSectionIndex -= 1;
      } else {
        return;
      }

      // if (targetSectionIndex !== currentSectionIndex) {
        scrollToSection(sections[targetSectionIndex]);
        setCurrentSectionIndex(targetSectionIndex);
      // }
    };

    setCurrentSectionIndex(0);
    let cleanup = () => {}; // 클린업 함수를 빈 함수로 초기화

    if (boxContainerRef.current) {
      if(screen !== "pc") {
        boxContainerRef.current.addEventListener('touchstart', handleTouchStart);
        boxContainerRef.current.addEventListener('touchmove', checkWheel);
        boxContainerRef.current.addEventListener('touchend', checkWheel);
        boxContainerRef.current.addEventListener('wheel', checkWheel, {
          passive: false,
        });
        boxContainerRef.current.addEventListener('scroll', handleScroll);

      } else {
        boxContainerRef.current.addEventListener('wheel', handleWheel, {
          passive: false,
        });
        // boxContainerRef.current.addEventListener('touchstart', handleTouchStart);
        // boxContainerRef.current.addEventListener('touchmove', handleTouchMove);
        // boxContainerRef.current.addEventListener('touchend', handleTouchEnd);
      }

      cleanup = () => {
        if (boxContainerRef.current) {
          if(screen !== "pc") {
            boxContainerRef.current.removeEventListener('touchstart', handleTouchStart);
            boxContainerRef.current.removeEventListener('touchmove', checkWheel);
            boxContainerRef.current.removeEventListener('touchend', checkWheel);
            boxContainerRef.current.removeEventListener('wheel', checkWheel);
            boxContainerRef.current.removeEventListener('scroll', handleScroll);
          } else {
            boxContainerRef.current.removeEventListener('wheel', handleWheel);
            // boxContainerRef.current.removeEventListener('touchstart', handleTouchStart);
            // boxContainerRef.current.removeEventListener('touchmove', handleTouchMove);
            // boxContainerRef.current.removeEventListener('touchend', handleTouchEnd);

          }
        }
      };
    }
    return cleanup;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screen]);

  return (
    <HomePresenter 
      slideImages={MainBannerList}
      ciImages={CIList}
      currentSectionIndex={currentSectionIndex}
      boxContainerRef={boxContainerRef}
    />
  );
}

export default HomeContainer;